import "../../shared/sparkle_namespace.js";

/*
DEPRECATION NOTICE: This file is being deprecated in favour of extending admin/page_builder/modals/base.coffee
                    Sublcass the Sparkle.PageBuilder.Modal.Base class with your new custom modal.
/*

/**
 * @module page-builder
 */
(function () {
  "use strict";

  function buildButtonElement(title, callback, type) {
    var button = document.createElement("button");
    button.innerHTML = title;
    button.addEventListener("click", callback);
    if (type) {
      button.classList.add(type);
    }

    return button;
  }

  var Modal = function Modal() {
    var self = {
      template: "modal",
      initialize: function (callback) {
        this.dialog = document.createElement("div");
        this.backdrop = document.createElement("div");

        this.dialog.innerHTML = Sparkle.HandlebarsTemplates[this.template]();

        this.dialog.classList.add("page-builder-modal");
        this.backdrop.classList.add("page-builder-backdrop");

        this.closeButton = this.dialog.querySelector(".pane-header .close");
        this.closeButton.addEventListener("click", this.remove.bind(this));

        this.backdrop.appendChild(this.dialog);
        if (document.body) {
          document.body.appendChild(this.backdrop);
        }
        this.content = this.dialog.querySelector(".pane-body");
        this.hide();

        if (callback) {
          callback(this);
        }
      },

      setContent: function (html) {
        var content = this.dialog.querySelector(".pane-body");
        content.innerHTML = html;
        return content;
      },

      addButton: function (title, callback, primary) {
        var type = primary ? "primary" : null;
        var button = buildButtonElement(title, callback, type);
        this.dialog.querySelector(".pane-footer").appendChild(button);
      },

      addSecondaryButton: function (title, callback, type) {
        jQuery(this.dialog.querySelector(".pane-footer")).prepend(
          jQuery(buildButtonElement(title, callback, type || "destroy")),
        );
      },

      addPrimaryButton: function (title, callback, closeOnEnter) {
        this.addButton(title, callback, true);
        if (closeOnEnter) {
          this.closeOnEnterPress(this.dialog);
        }
      },

      /**
       * Adds an event listener on to the primary button. Listens for enter
       * press and preforms callback function.
       * dialogBox : this modal element
       */
      closeOnEnterPress: function (dialogBox) {
        dialogBox.addEventListener("keypress", function (e) {
          var key = e.which || e.keyCode;
          if (key === 13) {
            dialogBox.querySelector(".pane-footer .primary").trigger("click");
          }
        });
      },

      setTitle: function (title) {
        var element = this.dialog.querySelector(".pane-header .title");
        element.innerHTML = title;
      },

      show: function () {
        this.dialog.classList.remove("hidden");
        this.backdrop.classList.remove("hidden");
      },

      hide: function () {
        this.dialog.classList.add("hidden");
        this.backdrop.classList.add("hidden");
      },

      remove: function () {
        this.hide();
        this.dialog.remove();
        this.backdrop.remove();
      },
    };
    self.initialize.apply(self, arguments);
    return self;
  };

  Sparkle.PageBuilder.Modal = Sparkle.PageBuilder.Modal || {};
  Sparkle.PageBuilder.Modal.Deprecated = Modal;
})();
